import Constants from "expo-constants";
import { updateId } from "expo-updates";
import { applicationId, nativeApplicationVersion, nativeBuildVersion } from "expo-application";
import * as ImagePicker from "expo-image-picker";
import buildNumbers from "../../build_numbers.json";
import { useLibraryStatus } from "../hooks/push-notification";
import { useContactsStatus } from "../hooks/contacts";
import { Pressable, StyleSheet } from "react-native";
import { notificationEnabledState } from "../atoms/push-notifications";
import { useAtomValue } from "jotai";
import { useTheme } from "../hooks/use-theme";
import { useMemo } from "react";
import Text from "./Text";
import { useSetAlert } from "../hooks/use-set-alert";
import { useI18n } from "../hooks/i18n-hooks";

type AppVersionProps = {
    onPress?: () => void;
};

const AppVersion = ({ onPress }: AppVersionProps) => {
    const styles = useStyles();
    const i18n = useI18n();

    const notificationEnabled = useAtomValue(notificationEnabledState);
    const [cameraStatus] = ImagePicker.useCameraPermissions();
    const libraryStatus = useLibraryStatus();
    const contactsStatus = useContactsStatus();
    const { setAlert } = useSetAlert();

    return (
        <Pressable
            onPress={onPress}
            onLongPress={() => {
                setAlert({
                    title: i18n.t("version_informations"),
                    message: [
                        `Environment: ${(Constants.expoConfig?.extra?.appEnv as string) || ""}`,
                        `Update ID: ${updateId || ""}`,
                        `App ID: ${applicationId || ""}`,
                        `App version: ${
                            nativeApplicationVersion || buildNumbers.storeVersion || ""
                        }`,
                        `Build version: ${nativeBuildVersion || ""}`,
                        `Notification status: ${notificationEnabled || ""}`,
                        `Camera status: ${cameraStatus?.granted || ""}`,
                        `Library status: ${libraryStatus || ""}`,
                        `Contacts status: ${contactsStatus || ""}`,
                    ].join("\n\n"),
                });
            }}
        >
            <Text style={styles.appVersionValue}>
                Version {nativeApplicationVersion || buildNumbers.storeVersion || ""}
                {nativeBuildVersion ? `/ ${nativeBuildVersion}` : ""}
            </Text>
        </Pressable>
    );
};

const useStyles = () => {
    const { fonts, colors } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                appVersionTitle: {
                    ...fonts.bodyLarge,
                    color: colors.greyAccessible,
                    fontSize: 14,
                    textAlign: "center",
                },
                appVersionValue: {
                    ...fonts.bodyMedium,
                    color: colors.greyAccessible,
                    fontSize: 14,
                    textAlign: "center",
                },
            }),
        [colors.greyAccessible, fonts.bodyLarge, fonts.bodyMedium],
    );
};

export default AppVersion;
